import { render, staticRenderFns } from "./ShopAutocomplete.vue?vue&type=template&id=ab58db04&"
import script from "./ShopAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ShopAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!E:/CBK/BPI/v1.0.9/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VListTileContent})
